export const AUTH_TOKEN = 'auth_token'
export const ROLES = 'roles'
export const HALF_CHECKED_ROLES = 'half_checked_roles'
export const USER_TYPE = 'userType'
export const USER_ID = 'user_id'